var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170.59 169.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:.7;}.cls-1,.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "65.75 134.84 40.15 90.31 94.28 89.86 119.75 135.02 65.75 134.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "170.59 134.63 119.75 135.02 67.96 43.67 93.17 0 170.59 134.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "85.76 169.63 35.15 169.63 14.94 133.98 40.15 90.31 85.76 169.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.44,154.34c4.17,0,7.5,3.39,7.5,7.65s-3.33,7.65-7.5,7.65-7.44-3.39-7.44-7.65,3.31-7.65,7.44-7.65ZM7.44,168.2c3.37,0,5.97-2.72,5.97-6.22s-2.6-6.22-5.97-6.22-5.91,2.72-5.91,6.22,2.58,6.22,5.91,6.22ZM4.88,158h3.04c1.49,0,2.49.94,2.49,2.41,0,1.22-.8,1.93-1.45,2.1v.04s.08.08.27.44l1.51,2.91h-1.63l-1.47-3.06h-1.28v3.06h-1.49v-7.9ZM7.63,161.75c.78,0,1.28-.5,1.28-1.34s-.5-1.28-1.28-1.28h-1.26v2.62h1.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.24756f85aec6a36162ec19fae1c33927.svg";
export { ForwardRef as ReactComponent };